module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image@2-f924ba80d8f6f8e634fc5b3b043d88da.jpg";